import { render, staticRenderFns } from "./registeredPage.vue?vue&type=template&id=326d1bc3&scoped=true&"
import script from "./registeredPage.vue?vue&type=script&lang=js&"
export * from "./registeredPage.vue?vue&type=script&lang=js&"
import style0 from "./registeredPage.vue?vue&type=style&index=0&id=326d1bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326d1bc3",
  null
  
)

export default component.exports